import { render, staticRenderFns } from "./nursingInstitutionAged.vue?vue&type=template&id=099242ba&"
import script from "./nursingInstitutionAged.vue?vue&type=script&lang=ts&"
export * from "./nursingInstitutionAged.vue?vue&type=script&lang=ts&"
import style0 from "./nursingInstitutionAged.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports